import React, { useState } from "react";

const pasos = [
  { id: 1, nombre: "No pagado", descripcion: "Tu pedido falta pagarlo" },
  { id: 2, nombre: "Pagado", descripcion: "Tu pedido está pagado" },
  { id: 3, nombre: "Asignacion", descripcion: "Tu pedido está siendo asignado" },
  { id: 4, nombre: "Saliendo", descripcion: "Tu pedido está saliendo" },
  { id: 5, nombre: "En camino", descripcion: "Tu pedido está en ruta" },
  { id: 6, nombre: "Llegando", descripcion: "Tu pedido está cerca de su destino" },
  { id: 7, nombre: "Entregado", descripcion: "Tu pedido ha sido entregado" },
];

const styles = {
  priceText: {
    color: "#8B0000",
    fontSize: "1.5rem",
    fontWeight: "600",
  },
};

const GetAgenda = async (trackingCode) => {
  try {
    const response = await fetch("https://frabas.cl/backend/pago.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ codigo: trackingCode }),
    });
    const data = await response.json();
    if (data.success) {
      return data.data; // Suponemos que data.data es un arreglo con pedidos
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error al obtener datos de agenda:", error);
    return null;
  }
};

const estadoMap = {
  "no pagado": 1,
  "pagado": 2,
  "asignacion": 3,
  "saliendo": 4,
  "en camino": 5,
  "llegando": 6,
  "entregado": 7,
};

const Seguimiento = () => {
  const [codigo, setCodigo] = useState("");
  const [pedido, setPedido] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleBuscar = async () => {
    if (!codigo.trim()) {
      setError("Por favor ingresa un código válido");
      setPedido(null);
      return;
    }
    setError("");
    setLoading(true);
    const data = await GetAgenda(codigo.trim());
    if (data && data.length > 0) {
      setPedido(data[0]);
    } else {
      setPedido(null);
      setError("Pedido no encontrado");
    }
    setLoading(false);
  };

  // Convertimos el estado textual a número para el progreso
  const estadoActual = pedido?.estado
    ? estadoMap[pedido.estado.toLowerCase()] || 0
    : 0;

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Título */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-[#8B0000] mb-4">
            Seguimiento de Pedido
          </h1>
          <p className="text-lg text-gray-600">Ingresa tu código para rastrear tu pedido</p>
        </div>

        {/* Input y botón de búsqueda */}
        <div className="flex justify-center mb-16">
          <div className="w-full md:w-2/3 relative flex">
            <input
              type="text"
              placeholder="Ingresa tu código de seguimiento"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleBuscar();
                }
              }}
              className="w-full border-2 border-gray-200 rounded-l-lg p-4 pl-12 focus:outline-none focus:ring-2 focus:ring-[#8B0000] focus:border-[#8B0000] text-lg"
            />
            <button
              onClick={handleBuscar}
              className="bg-[#8B0000] hover:bg-red-700 text-white font-semibold px-6 rounded-r-lg transition"
              disabled={loading}
            >
              {loading ? "Buscando..." : "Buscar"}
            </button>
            <svg
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-6 h-6 text-gray-400 pointer-events-none"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>

        {/* Mostrar error si existe */}
        {error && (
          <div className="text-center text-red-600 font-semibold mb-8">{error}</div>
        )}

        {/* Mostrar barra de progreso solo si hay pedido */}
        {pedido && (
          <>
            <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
              <div className="relative">
                {/* Línea de progreso */}
                <div className="absolute top-1/2 left-0 w-full h-1 bg-gray-200 transform -translate-y-1/2"></div>
                <div
                  className="absolute top-1/2 left-0 h-1 bg-[#8B0000] transform -translate-y-1/2 transition-all duration-500"
                  style={{ width: `${((estadoActual - 1) / (pasos.length - 1)) * 100}%` }}
                ></div>

                {/* Pasos */}
                <div className="relative flex justify-between">
                  {pasos.map((paso, index) => (
                    <div key={paso.id} className="flex flex-col items-center">
                      <div
                        className={`w-10 h-10 rounded-full flex items-center justify-center mb-2 ${
                          (index + 1) <= estadoActual
                            ? "bg-[#8B0000] text-white"
                            : "bg-gray-200 text-gray-400"
                        }`}
                      >
                        {(index + 1) <= estadoActual ? (
                          <svg
                            className="w-6 h-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        ) : (
                          <span className="text-sm font-medium">{paso.id}</span>
                        )}
                      </div>
                      <div className="text-center">
                        <div
                          className={`font-medium ${
                            (index + 1) <= estadoActual ? "text-[#8B0000]" : "text-gray-400"
                          }`}
                        >
                          {paso.nombre}
                        </div>
                        <div className="text-sm text-gray-500 mt-1">{paso.descripcion}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Información adicional real del pedido */}
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h2 className="text-2xl font-bold text-[#8B0000] mb-4">Información del Envío</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <p className="text-gray-600">Número de seguimiento:</p>
                  <p className="font-medium">{pedido.numeroSeguimiento || codigo}</p>
                </div>
                <div>
                  <p className="text-gray-600">Fecha estimada de entrega:</p>
                  <p className="font-medium">{pedido.fecha_agenda || "Pendiente"}</p>
                </div>
                <div>
                  <p className="text-gray-600">Hora estimada de entrega:</p>
                  <p className="font-medium">{pedido.hora_agenda || "Pendiente"}</p>
                </div>
                <div>
                  <p className="text-gray-600">Precio:</p>
                  <p className="font-medium" style={styles.priceText}>
                    ${pedido.precio || "Pendiente"} CLP
                  </p>
                </div>
                <div>
                  <p className="text-gray-600">Dirección inicio:</p>
                  <p className="font-medium">{pedido.lugar_desde || "Pendiente"}</p>
                </div>
                <div>
                  <p className="text-gray-600">Dirección fin:</p>
                  <p className="font-medium">{pedido.lugar_hasta || "Pendiente"}</p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Seguimiento;
